function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "rgb(0,0,0)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 4.25c-2.62335 0-4.75 2.12665-4.75 4.75 0 2.6234 2.12665 4.75 4.75 4.75 2.6234 0 4.75-2.1266 4.75-4.75 0-2.62335-2.1266-4.75-4.75-4.75zm-3.25 4.75c0-1.79493 1.4551-3.25 3.25-3.25s3.25 1.45507 3.25 3.25c0 1.7949-1.4551 3.25-3.25 3.25s-3.25-1.4551-3.25-3.25z",
    fill: "rgb(0,0,0)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 1.25c-5.93706 0-10.75 4.81294-10.75 10.75 0 3.0485 1.26989 5.8016 3.30751 7.7571 1.93082 1.8529 4.55431 2.9929 7.44249 2.9929 2.8882 0 5.5117-1.14 7.4425-2.9929 2.0376-1.9555 3.3075-4.7086 3.3075-7.7571 0-5.93706-4.8129-10.75-10.75-10.75zm-9.25 10.75c0-5.10863 4.14137-9.25 9.25-9.25 5.1086 0 9.25 4.14137 9.25 9.25 0 2.1948-.7637 4.2103-2.0411 5.7966-.794-1.5138-2.3803-2.5466-4.2089-2.5466h-6c-1.82857 0-3.41487 1.0328-4.20891 2.5466-1.27737-1.5863-2.04109-3.6018-2.04109-5.7966zm12.25 4.75c1.4339 0 2.6521.9292 3.0831 2.2185-1.6266 1.4213-3.7537 2.2815-6.0831 2.2815-2.32938 0-4.45648-.8602-6.08313-2.2815.43104-1.2893 1.64926-2.2185 3.08313-2.2185z",
    fill: "rgb(0,0,0)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2b7b2858ba835822afa7801098e94111.svg";
export { ForwardRef as ReactComponent };